import React, { useContext, useEffect, useState } from "react";
import '../../../Style/VATTable.scss'
import axios from "axios";
import { ApiLink } from "../../../APILink/ApiLink";
import authHeader from "../../../Auth/authHeader";
import { errorAlert } from "../../../Components/Alerts";
import { FiscalYearContext } from "../../../FiscalYear/FiscalYearContext";

export default function FirstTable(props) {
    const [data, setData] = useState([]);
    const [txf71, setTxf71] = useState(0);
    const [txf72, setTxf72] = useState(0);
    const [txf68, setTxf68] = useState(0);
    const [txf30, setTxf30] = useState(0);

    const { fiscalYear } = useContext(FiscalYearContext);

    // let txf68 = vatYearBalance;
    // let txf30 = data && data.length > 0 ? (data[0].Total_TVSH_8_dhe_18 !== null ? data[0].Total_TVSH_8_dhe_18 : 0) : 0;
    let txf67 = data && data.length > 0 ? (data[0]._67_Total_TVSH_8_dhe_18 !== null ? data[0]._67_Total_TVSH_8_dhe_18 : 0) : 0;

    const [vatYearBalance, setVATYearBalance] = useState(0);
    const [vat01, setVat01] = useState(0);
    const [vat02, setVat02] = useState(0);
    const [vat03, setVat03] = useState(0);
    const [vat04, setVat04] = useState(0);
    const [vat05, setVat05] = useState(0);
    const [vat06, setVat06] = useState(0);
    const [vat07, setVat07] = useState(0);
    const [vat08, setVat08] = useState(0);
    const [vat09, setVat09] = useState(0);
    const [vat10, setVat10] = useState(0);
    const [vat11, setVat11] = useState(0);
    const [vat12, setVat12] = useState(0);


    const headers = authHeader();

    // Përditëso txf30 kur props.month ndryshon
    useEffect(() => {
        if (props.month !== 0) {
            try {
                const fetchData = async () => {
                    const headers = authHeader();
                    const response = await axios.get(ApiLink.API_URL + 'TaxReport/vatDeclaration', { headers, params: { month: props.month, fiscalYear: fiscalYear } });
                    setData(response.data);
                    setTxf30(response.data[0]?.Total_TVSH_8_dhe_18 || 0);
                };
                fetchData();
            } catch (error) {
                console.log(error);
            }
        }
    }, [props.month, fiscalYear]);


    const fetchVATYearBalance = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'TaxReport/VATYearBalance', { headers, params: { fiscalYear: fiscalYear } });
            setVATYearBalance(response.data[0]?.Debit || 0);

        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchVATMonthBalance = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'TaxReport/VATMonthBalance', { headers, params: { fiscalYear: fiscalYear } });
            setVat01(response.data[0]?.Difference || 0);
            setVat02(response.data[1]?.Difference || 0);
            setVat03(response.data[2]?.Difference || 0);
            setVat04(response.data[3]?.Difference || 0);
            setVat05(response.data[4]?.Difference || 0);
            setVat06(response.data[5]?.Difference || 0);
            setVat07(response.data[6]?.Difference || 0);
            setVat08(response.data[7]?.Difference || 0);
            setVat09(response.data[8]?.Difference || 0);
            setVat10(response.data[9]?.Difference || 0);
            setVat11(response.data[10]?.Difference || 0);
            setVat12(response.data[11]?.Difference || 0);

        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const [janari68, setJanari68] = useState(0);

    const [shkurti68, setShkurti68] = useState(0);

    const [marsi68, setMarsi68] = useState(0);

    const [prilli68, setPrilli68] = useState(0);

    const [maj68, setMaj68] = useState(0);

    const [qershor68, setQershor68] = useState(0);

    const [korrik68, setKorrik68] = useState(0);

    const [gusht68, setGusht68] = useState(0);

    const [shtator68, setShtator68] = useState(0);

    const [tetor68, setTetor68] = useState(0);

    const [nentor68, setNentor68] = useState(0);

    const [dhjetor68, setDhjetor68] = useState(0);





    useEffect(() => {

        let jan68 = vatYearBalance;
        setJanari68(jan68);
        let jan71 = jan68 >= 0 ? Number(vatYearBalance) + Number(vat01) : 0

        let shk68 = jan71 >= 0 ? jan71 : 0;
        setShkurti68(shk68);
        let shk71 = shk68 >= 0 ? Number(shk68) + Number(vat02) : vat02;

        let mar68 = shk71 >= 0 ? shk71 : 0;
        setMarsi68(mar68);
        let mar71 = mar68 >= 0 ? Number(mar68) + Number(vat03) : vat03;

        let pr68 = mar71 >= 0 ? mar71 : 0;
        setPrilli68(pr68);
        let pr71 = pr68 >= 0 ? Number(pr68) + Number(vat04) : vat04;

        let ma68 = pr71 >= 0 ? pr71 : 0;
        setMaj68(ma68);
        let ma71 = ma68 >= 0 ? Number(ma68) + Number(vat05) : vat05;

        // let qe68 = ma71 >= 0 ? pr71 : 0;
        let qe68 = ma71 >= 0 ? ma71 : 0;
        setQershor68(qe68);
        let qe71 = qe68 >= 0 ? Number(qe68) + Number(vat06) : vat06;

        let ko68 = qe71 >= 0 ? qe71 : 0;
        setKorrik68(ko68);
        // let ko71 = ko68 >= 0 ? Number(qe68) + Number(vat07) : vat07;
        let ko71 = ko68 >= 0 ? Number(ko68) + Number(vat07) : vat07;

        let gu68 = ko71 >= 0 ? ko71 : 0;
        setGusht68(gu68);
        let gu71 = gu68 >= 0 ? Number(gu68) + Number(vat08) : vat08;

        let sht68 = gu71 >= 0 ? gu71 : 0;
        setShtator68(sht68);
        let sh71 = sht68 >= 0 ? Number(sht68) + Number(vat09) : vat09;

        let te68 = sh71 >= 0 ? sh71 : 0;
        setTetor68(te68);
        let te71 = te68 >= 0 ? Number(te68) + Number(vat10) : vat10;

        let ne68 = te71 >= 0 ? te71 : 0;
        setNentor68(ne68);
        let ne71 = ne68 >= 0 ? Number(ne68) + Number(vat11) : vat11;

        let dh68 = ne71 >= 0 ? ne71 : 0;
        setDhjetor68(dh68);
        let dh71 = dh68 >= 0 ? Number(dh68) + Number(vat12) : vat12;

    }, [vatYearBalance, vat01, vat02, vat03, vat04, vat05, vat06, vat07, vat08, vat09, vat10, vat11, vat12])

    useEffect(() => {
        const monthValues = {
            1: janari68,
            2: shkurti68,
            3: marsi68,
            4: prilli68,
            5: maj68,
            6: qershor68,
            7: korrik68,
            8: gusht68,
            9: shtator68,
            10: tetor68,
            11: nentor68,
            12: dhjetor68
        };

        const monthValue = monthValues[props.month] || 0;

        setTxf68(monthValue);

        const Txf71_72 = (monthValue + txf67) - txf30;
        if (Txf71_72 < 0) {
            setTxf72(Math.abs(Txf71_72));
            setTxf71(0);
        } else {
            setTxf71(Txf71_72);
            setTxf72(0);
        }
    }, [props.month, txf67, txf30, janari68, shkurti68, marsi68, prilli68, maj68, qershor68, korrik68, gusht68, shtator68, tetor68, nentor68, dhjetor68]);



    useEffect(() => {
        // fetchData(props.month);
        fetchVATYearBalance();
        fetchVATMonthBalance();
    }, [fiscalYear]);

    // Helper: extract a numeric value safely from data
    const v = (key) => ((data && data.length > 0 ? data[0][key] : 0) || 0);

    useEffect(() => {
        if (typeof props.onDataChange === "function") {
            props.onDataChange({ data, txf30, txf67, txf68, txf71, txf72 });
        }
    }, [data, txf30, txf67, txf68, txf71, txf72]);

    return (
        <div className="VATT__Wrapper">
          <table className="VATT__Table">
            {/* ─── Column headers ─────────────────────────────── */}
            <thead>
              <tr className="VATT__ColHead">
                <th className="VATT__Th--code">Kodi</th>
                <th>Përshkrimi</th>
                <th className="VATT__Th--num">Baza (€)</th>
                <th className="VATT__Th--code">Kodi TVSH</th>
                <th className="VATT__Th--num">TVSH (€)</th>
              </tr>
            </thead>

            <tbody>
              {/* ═══════════════════════════════════════════════ */}
              {/* SECTION 1 — FURNIZIMET                         */}
              {/* ═══════════════════════════════════════════════ */}
              <tr className="VATT__SectionRow">
                <td colSpan={5}>Furnizimet</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[9]</td>
                <td className="VATT__Td--desc">Shitjet e liruara pa të drejtë kreditimi</td>
                <td className="VATT__Td--num">{v("_9_Shitjet_Pa_Kreditim").toFixed(2)}</td>
                <td className="VATT__Td--empty">—</td>
                <td className="VATT__Td--empty">—</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[10]</td>
                <td className="VATT__Td--desc">Shitjet e liruara me të drejtë kreditimi</td>
                <td className="VATT__Td--num">{v("_10_Shitjet_Liruara_Me_Kreditim").toFixed(2)}</td>
                <td className="VATT__Td--empty">—</td>
                <td className="VATT__Td--empty">—</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[11]</td>
                <td className="VATT__Td--desc">Eksportet</td>
                <td className="VATT__Td--num">{v("_11_Eksportet").toFixed(2)}</td>
                <td className="VATT__Td--empty">—</td>
                <td className="VATT__Td--empty">—</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[12]</td>
                <td className="VATT__Td--desc">Shitjet e tatueshme me normën 18%</td>
                <td className="VATT__Td--num">{v("_12_Shitjet18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[13]</td>
                <td className="VATT__Td--num">{(v("_12_Shitjet18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[14]</td>
                <td className="VATT__Td--desc">Shitjet e tatueshme me normën 8%</td>
                <td className="VATT__Td--num">{v("_14_Shitjet8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[15]</td>
                <td className="VATT__Td--num">{(v("_14_Shitjet8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[16]</td>
                <td className="VATT__Td--desc">Nota debitore e lëshuar, nota kreditore e pranuar me normë 18%</td>
                <td className="VATT__Td--num">{v("_16_NotaDebitore18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[17]</td>
                <td className="VATT__Td--num">{(v("_16_NotaDebitore18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[18]</td>
                <td className="VATT__Td--desc">Nota debitore e lëshuar, nota kreditore e pranuar me normë 8%</td>
                <td className="VATT__Td--num">{v("_18_NotaDebitore8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[19]</td>
                <td className="VATT__Td--num">{(v("_18_NotaDebitore8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[20]</td>
                <td className="VATT__Td--desc">Fatura e borxhit të keq e pranuar, inkasimi i B.K. me normë 18%</td>
                <td className="VATT__Td--num">{v("_20_BorgjiKeq18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[21]</td>
                <td className="VATT__Td--num">{(v("_20_BorgjiKeq18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[22]</td>
                <td className="VATT__Td--desc">Fatura e borxhit të keq e pranuar, inkasimi i B.K. me normë 8%</td>
                <td className="VATT__Td--num">{v("_22_BorgjiKeq8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[23]</td>
                <td className="VATT__Td--num">{(v("_22_BorgjiKeq8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[24]</td>
                <td className="VATT__Td--desc">Rregullimet për të rritur TVSH-në me normë 18%</td>
                <td className="VATT__Td--num">{v("_24_Rregullimet18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[25]</td>
                <td className="VATT__Td--num">{(v("_24_Rregullimet18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[26]</td>
                <td className="VATT__Td--desc">Rregullimet / Ngarkesa e kundërt për Energjinë me normë 8%</td>
                <td className="VATT__Td--num">{v("_26_Rregullimet8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[27]</td>
                <td className="VATT__Td--num">{(v("_26_Rregullimet8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[28]</td>
                <td className="VATT__Td--desc">Blerjet që i nënshtrohen ngarkesës së kundërt</td>
                <td className="VATT__Td--num">{v("_28_NgarkesaKundert18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[29]</td>
                <td className="VATT__Td--num">{(v("_28_NgarkesaKundert18") * 0.18).toFixed(2)}</td>
              </tr>

              {/* Total furnizimet */}
              <tr className="VATT__SummaryRow">
                <td className="VATT__Td--code">[30]</td>
                <td className="VATT__Td--desc" colSpan={3}>Totali i TVSH-së së llogaritur</td>
                <td className="VATT__Td--num">{txf30.toFixed(2)}</td>
              </tr>

              {/* ═══════════════════════════════════════════════ */}
              {/* SECTION 2 — BLERJET                            */}
              {/* ═══════════════════════════════════════════════ */}
              <tr className="VATT__SectionRow">
                <td colSpan={5}>Blerjet</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[31]</td>
                <td className="VATT__Td--desc">Blerjet dhe importet pa TVSH</td>
                <td className="VATT__Td--num">{v("_31_BlerjetPaTVSH").toFixed(2)}</td>
                <td className="VATT__Td--empty">—</td>
                <td className="VATT__Td--empty">—</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[32]</td>
                <td className="VATT__Td--desc">Blerjet dhe importet investive pa TVSH</td>
                <td className="VATT__Td--num">{v("_32_Blerjet_dhe_Imp_Inv_PaTVSH").toFixed(2)}</td>
                <td className="VATT__Td--empty">—</td>
                <td className="VATT__Td--empty">—</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[33]</td>
                <td className="VATT__Td--desc">Blerjet dhe importet me TVSH jo të zbritshme</td>
                <td className="VATT__Td--num">{v("_33_Blerjet_dhe_Imp_Inv_me_TVSH_jo_TeZbritshme").toFixed(2)}</td>
                <td className="VATT__Td--empty">—</td>
                <td className="VATT__Td--empty">—</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[34]</td>
                <td className="VATT__Td--desc">Blerjet dhe importet investive me TVSH jo të zbritshme</td>
                <td className="VATT__Td--num">{v("_34_Blerjet_dhe_Imp_Inv_me_TVSH_jo_TeZbritshme").toFixed(2)}</td>
                <td className="VATT__Td--empty">—</td>
                <td className="VATT__Td--empty">—</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[35]</td>
                <td className="VATT__Td--desc">Importet me normë 18%</td>
                <td className="VATT__Td--num">{v("_35_Importet18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[36]</td>
                <td className="VATT__Td--num">{(v("_35_Importet18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[37]</td>
                <td className="VATT__Td--desc">Importet me normë 8%</td>
                <td className="VATT__Td--num">{v("_37_Importet8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[38]</td>
                <td className="VATT__Td--num">{(v("_37_Importet8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[39]</td>
                <td className="VATT__Td--desc">Importet investive me normë 18%</td>
                <td className="VATT__Td--num">{v("_39_ImportetInvestive18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[40]</td>
                <td className="VATT__Td--num">{(v("_39_ImportetInvestive18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[41]</td>
                <td className="VATT__Td--desc">Importet investive me normë 8%</td>
                <td className="VATT__Td--num">{v("_41_ImportetInvestive8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[42]</td>
                <td className="VATT__Td--num">{(v("_41_ImportetInvestive8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[43]</td>
                <td className="VATT__Td--desc">Blerjet vendore me normë 18%</td>
                <td className="VATT__Td--num">{v("_43_BlerjetVendore18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[44]</td>
                <td className="VATT__Td--num">{(v("_43_BlerjetVendore18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[45]</td>
                <td className="VATT__Td--desc">Blerjet vendore me normë 8%</td>
                <td className="VATT__Td--num">{v("_45_BlerjetVendore8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[46]</td>
                <td className="VATT__Td--num">{(v("_45_BlerjetVendore8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[47]</td>
                <td className="VATT__Td--desc">Blerjet investive vendore me normë 18%</td>
                <td className="VATT__Td--num">{v("_47_BlerjetInvestive18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[48]</td>
                <td className="VATT__Td--num">{(v("_47_BlerjetInvestive18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[49]</td>
                <td className="VATT__Td--desc">Blerjet investive vendore me normë 8%</td>
                <td className="VATT__Td--num">{v("_49_BlerjetInvestive8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[50]</td>
                <td className="VATT__Td--num">{(v("_49_BlerjetInvestive8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[51]</td>
                <td className="VATT__Td--desc">Blerjet nga fermerët vendorë me normë 8%</td>
                <td className="VATT__Td--num">{v("_51_BlerjetNgaFermeret8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[52]</td>
                <td className="VATT__Td--num">{(v("_51_BlerjetNgaFermeret8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[53]</td>
                <td className="VATT__Td--desc">Nota debitore e pranuar, nota kreditore e lëshuar me normë 18%</td>
                <td className="VATT__Td--num">{v("_53_NotaKreditore18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[54]</td>
                <td className="VATT__Td--num">{(v("_53_NotaKreditore18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[55]</td>
                <td className="VATT__Td--desc">Nota debitore e pranuar, nota kreditore e lëshuar me normë 8%</td>
                <td className="VATT__Td--num">{v("_55_NotaKreditore8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[56]</td>
                <td className="VATT__Td--num">{(v("_55_NotaKreditore8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[57]</td>
                <td className="VATT__Td--desc">Fatura e borxhit të keq e lëshuar, pagesa e B.K. me normë 18%</td>
                <td className="VATT__Td--num">{v("_57_BorgjiKeq18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[58]</td>
                <td className="VATT__Td--num">{(v("_57_BorgjiKeq18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[59]</td>
                <td className="VATT__Td--desc">Fatura e borxhit të keq e lëshuar, pagesa e B.K. me normë 8%</td>
                <td className="VATT__Td--num">{v("_59_BorgjiKeq8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[60]</td>
                <td className="VATT__Td--num">{(v("_59_BorgjiKeq8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[61]</td>
                <td className="VATT__Td--desc">Rregullimet për të ulur TVSH-në me normë 18%</td>
                <td className="VATT__Td--num">{v("_61_Rregullimet18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[62]</td>
                <td className="VATT__Td--num">{(v("_61_Rregullimet18") * 0.18).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[63]</td>
                <td className="VATT__Td--desc">Rregullimet / Ngarkesa e kundërt për Energjinë me normë 8%</td>
                <td className="VATT__Td--num">{v("_63_Rregullimet8").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[64]</td>
                <td className="VATT__Td--num">{(v("_63_Rregullimet8") * 0.08).toFixed(2)}</td>
              </tr>

              <tr className="VATT__Row">
                <td className="VATT__Td--code">[65]</td>
                <td className="VATT__Td--desc">E drejta e kreditimit të TVSH-së — ngarkesa e kundërt 18%</td>
                <td className="VATT__Td--num">{v("_65_NgarkesaKundert18").toFixed(2)}</td>
                <td className="VATT__Td--code VATT__Td--vatcode">[66]</td>
                <td className="VATT__Td--num">{(v("_65_NgarkesaKundert18") * 0.08).toFixed(2)}</td>
              </tr>

              {/* Total blerjet */}
              <tr className="VATT__SummaryRow">
                <td className="VATT__Td--code">[67]</td>
                <td className="VATT__Td--desc" colSpan={3}>Totali i TVSH-së së zbritshme</td>
                <td className="VATT__Td--num">{txf67.toFixed(2)}</td>
              </tr>

              {/* ═══════════════════════════════════════════════ */}
              {/* SECTION 3 — KALKULIMI                          */}
              {/* ═══════════════════════════════════════════════ */}
              <tr className="VATT__SectionRow">
                <td colSpan={5}>Kalkulimi</td>
              </tr>

              <tr className="VATT__CalcRow">
                <td className="VATT__Td--code">[68]</td>
                <td className="VATT__Td--desc">Teprica e TVSH-së e bartur nga muaji i kaluar</td>
                <td className="VATT__Td--colspan" colSpan={3}>{txf68.toFixed(2)}</td>
              </tr>

              <tr className="VATT__CalcRow">
                <td className="VATT__Td--code">[69]</td>
                <td className="VATT__Td--desc">Balanca kreditore e mbetur &nbsp;<span style={{color:"#6f9684",fontSize:"11px"}}>= (67 + 68 − 30) &gt; 0</span></td>
                <td className="VATT__Td--colspan" colSpan={3}>{v("_65_NgarkesaKundert18").toFixed(2)}</td>
              </tr>

              <tr className="VATT__CalcRow">
                <td className="VATT__Td--code">[70]</td>
                <td className="VATT__Td--desc">Kërkesa për rimbursim</td>
                <td className="VATT__Td--colspan" colSpan={3}>{v("_65_NgarkesaKundert18").toFixed(2)}</td>
              </tr>

              {/* Credit row */}
              <tr className="VATT__CreditRow">
                <td className="VATT__Td--code">[71]</td>
                <td className="VATT__Td--desc">Kreditimi i TVSH-së për muajin pasues &nbsp;<span style={{fontSize:"11px",opacity:0.8}}>= (69 − 70)</span></td>
                <td className="VATT__Td--num" colSpan={3}>{txf71.toFixed(2)}</td>
              </tr>

              {/* Pay row */}
              <tr className="VATT__PayRow">
                <td className="VATT__Td--code">[72]</td>
                <td className="VATT__Td--desc">TVSH që duhet të paguhet &nbsp;<span style={{fontSize:"11px",opacity:0.8}}>= (30 − 67 − 68) &gt; 0</span></td>
                <td className="VATT__Td--num" colSpan={3}>{txf72.toFixed(2)}</td>
              </tr>

            </tbody>
          </table>
        </div>
    )
}
